import QuantityColumn, { StorePart } from './components/QuantityColumn'

function render( storePart: StorePart ) {
	return (
		<QuantityColumn storePart={storePart} />
	)
}

export default {
	name: 'Available',
	render,
}
